import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18f67679&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=18f67679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f67679",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Multimedia: require('/var/www/html/fantini/frontend-2/components/multimedia/index.vue').default,VectorIcon: require('/var/www/html/fantini/frontend-2/components/vector/icon/index.vue').default,Btn: require('/var/www/html/fantini/frontend-2/components/btn/index.vue').default,ModalNeedsUser: require('/var/www/html/fantini/frontend-2/components/modal/needs-user/index.vue').default})
